// iter157 — Central permission constants (mirror /app/backend/permissions.py).
// Every UI gate MUST resolve through these — no hardcoded role checks
// in components.

export const LEVELS = {
  NO_ACCESS: "no_access",
  VIEW_ONLY: "view_only",
  EDIT: "edit",
  FULL_CONTROL: "full_control",
};

export const LEVEL_RANK = {
  no_access: 0,
  view_only: 1,
  edit: 2,
  full_control: 3,
};

export const LEVEL_LABELS = {
  no_access: "No Access",
  view_only: "View Only",
  edit: "Edit",
  full_control: "Full Control",
};

// Categorised modules (kept in the same order as backend `permissions.py`).
export const MODULE_CATEGORIES = [
  {
    name: "Sales",
    modules: [
      { slug: "clients", label: "Clients" },
      { slug: "leads", label: "Leads" },
      { slug: "bookings", label: "Bookings" },
      { slug: "proposal", label: "Proposal" },
    ],
  },
  {
    name: "Finance",
    modules: [
      { slug: "financial_center", label: "Financial Center" },
      { slug: "payments", label: "Payments" },
      { slug: "invoice", label: "Invoice" },
      { slug: "cash_book", label: "Office Cash Book" },
    ],
  },
  {
    name: "Operations",
    modules: [
      { slug: "shoot_crew", label: "Shoot Crew" },
      { slug: "team", label: "Team" },
      { slug: "event_management", label: "Event Management" },
      { slug: "gallery", label: "Gallery" },
      { slug: "post_production", label: "Post Production" },
      { slug: "face_recognition", label: "Face Recognition" },
    ],
  },
  {
    name: "Administration",
    modules: [
      { slug: "dashboard", label: "Dashboard" },
      { slug: "reports", label: "Reports" },
      { slug: "users", label: "Users" },
      { slug: "settings", label: "Settings" },
      { slug: "analytics", label: "Analytics" },
    ],
  },
];

export const ALL_MODULES = MODULE_CATEGORIES.flatMap((c) => c.modules);

// Compare two levels: rank(a) >= rank(b) ?
export function levelAtLeast(a, b) {
  return (LEVEL_RANK[a] ?? 0) >= (LEVEL_RANK[b] ?? 0);
}
